import $http from './http.js';
import numeral from 'numeral'

export default {

    install(Vue, options) {
        Vue.prototype.$http = $http;

        Vue.prototype.YMD = 'YYYY-MM-DD';
        Vue.prototype.YMDHm = 'YYYY-MM-DD HH:mm';
        Vue.prototype.YMDHms = 'YYYY-MM-DD HH:mm:ss';
        Vue.prototype.dateNow = () => moment.utc().format(Vue.prototype.YMD);
        Vue.prototype.formatDate = function (value, format = this.YMD) {
            return value == null ? null : moment.utc(value).format(format);
        };
        Vue.prototype.formatDateTime = function (value) {
            return value == null ? null : moment.utc(value).format(this.YMDHm);
        };

        Vue.prototype.properties = properties;

        Vue.prototype.isValidAmount = (val, currency) =>
            (currency !== 'USC' && currency !== 'EUC' ? /^\d{1,}(\.\d{0,2})?$/ : /^\d{1,}(\.\d{0,4})?$/).test(val);
        Vue.prototype.isValidCardholderName = (val) => /^[A-Za-z.\s]+$/.test(val);

        Vue.mixin({});

        Vue.prototype.loadScript = (path) => {
            return new Promise(function (resolve, reject) {
                const script = document.createElement('script');
                script.onload = resolve;
                script.async = true;
                script.src = path;
                document.head.appendChild(script);
            });
        };

        Vue.prototype.loadStyle = (path) => {
            return new Promise(function (resolve, reject) {
                const file = document.createElement('link');
                file.rel = 'stylesheet';
                file.type = "text/css";
                file.href = path;
                file.onload = resolve;
                file.async = true;
                document.head.appendChild(file)
            });
        };

        Vue.prototype.BITCOIN_NUMBER_PRECISION = 8;
        Vue.prototype.formatNumber = function (value, precision = 2, nbsp = false, format = null) {
            if (_.isNil(value) || isNaN(value)) {
                return null;
            }
            const finalFormat = format || '0,0.' + '0'.repeat(precision);
            const formattedValue = numeral(value).format(finalFormat);
            if (nbsp) {
                return formattedValue.replace(/\s/g, '&nbsp');
            }
            return formattedValue;
        };
        Vue.prototype.colorNumberClass = function (value) {
            if (isNaN(value)) {
                return null;
            }
            return value >= 0 ? 'text-green' : 'text-red';
        };

        Vue.prototype.copyTextToClipboard = function (text, successCallback, failCallback) {
            const textArea = document.createElement("textarea");
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;
            textArea.style.width = '2em';
            textArea.style.height = '2em';
            textArea.style.padding = 0;
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';
            textArea.style.background = 'transparent';

            const onFail = () => _.isFunction(failCallback) && failCallback();
            const onSuccess = () => _.isFunction(successCallback) && successCallback();

            textArea.value = text;

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                const successful = document.execCommand('copy');
                successful ? onSuccess() : onFail();
            } catch (err) {
                onFail();
            }

            document.body.removeChild(textArea);
        };
    }
}
